import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { post } from '../Auths/AuthToken';
import ConsultationPopup from './ConsultationPopup';
import ConsultationMigrationPopup from './ConsultationMigrationPopup';
import CounsellingPopup from './CounsellingPopup';
import SuperBillPopup from './SuperBillPopup';
import DemographicsPopup from './DemographicsPopup';
import RenderDemoGraphics from './soapNoteTemplateData/RenderDemoGraphics';
import RenderGeneralDetails from './soapNoteTemplateData/RenderGeneralDetails';
import { DEFAULT_LOCAL_PATH } from '../../constents';
import RenderCounselingFollowUp from './soapNoteTemplateData/RenderCounselingFollowUp';
import BioPsychoSocialPopUp from './BioPsychoSocialPopUp';
import RenderBioPsychoSocial from './soapNoteTemplateData/RenderBioPsychoSocial';
import RenderConsultation from './soapNoteTemplateData/RenderConsultation';
import setUiMessage from '../../Utilities/Tostify';
import { preLineClass } from '../../Utilities/Utilities';
import PatVisitRightSidebar from './PatVisitRightSidebar';
import CustomCounsellingOnePopup from './CustomCounsellingOnePopup';
import RenderCustomCounselingOne from './soapNoteTemplateData/RenderCustomCounselingOne';
import RenderCustomCounselingTwo from './soapNoteTemplateData/RenderCustomCounselingTwo';
import CustomCounsellingTwoPopup from './CustomCounsellingTwoPopup';
import RenderCustomCounselingThree from './soapNoteTemplateData/RenderCustomCounselingThree';
import CustomCounsellingThreePopup from './CustomCounsellingThreePopup';
import RenderCustomCounselingFour from './soapNoteTemplateData/RenderCustomCounselingFour';
import CustomCounsellingFourPopup from './CustomCounsellingFourPopup';
import AddendumPopup from './AddendumPopup';
import ProofOfAppPopup from './ProofOfAppPopup';
import RevisionHxListPopup from './RevisionHxListPopup';
import ReactDOMServer from 'react-dom/server';
import PrintLayout from '../Layouts/PrintLayout';
import CounselingPrintPopup from './CounselingPrintPopup';
import SoapNotePopup from './SoapNotePopup';
import RenderSoapCounsellingData from './soapNoteTemplateData/RenderSoapCounsellingData';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import useMessageHandler from '../../hooks/NablaIntigration';
import {
  setRenderFormData,
  setUnlockFlag,
} from '../../redux/slices/Notes/counsellingNoteSlice';
import { useDispatch, useSelector } from 'react-redux';
import RenderCustomCounselingNine from './soapNoteTemplateData/RenderCustomCounselingNine';
import CustomCounsellingNinePopup from './CustomCounsellingNinePopup';
import RenderCustomCounselingTen from './soapNoteTemplateData/RenderCustomCounselingTen';
import CustomCounsellingTenPopup from './CustomCounsellingTenPopup';
import RenderCustomCounselingFive from './soapNoteTemplateData/RenderCustomCounselingFive';
import CustomCounsellingFivePopup from './CustomCounsellingFivePopup';
import RenderCustomCounselingSix from './soapNoteTemplateData/RenderCustomCounselingSix';
import RenderCustomCounselingSeven from './soapNoteTemplateData/RenderCustomCounselingSeven';
import RenderCustomCounselingEight from './soapNoteTemplateData/RenderCustomCounselingEight';
import CustomCounsellingSixPopup from './CustomCounsellingSixPopup';
import CustomCounsellingSevenPopup from './CustomCounsellingSevenPopup';
import CustomCounsellingEightPopup from './CustomCounsellingEightPopup';
import { setAllDataOne } from '../../redux/slices/patient/customCounsellingOneSlice';
import { setAllDataTwo } from '../../redux/slices/patient/customCounsellingTwoSlice';
import { setAllDataThree } from '../../redux/slices/patient/customCounsellingThreeSlice';
import { setAllDataFour } from '../../redux/slices/patient/customCounsellingFourSlice';
import { setAllDataFive } from '../../redux/slices/patient/customCounsellingFiveSlice';
import { setAllDataSix } from '../../redux/slices/patient/customCounsellingSixSlice';
import { setAllDataSeven } from '../../redux/slices/patient/customCounsellingSevenSlice';
import { setAllDataEight } from '../../redux/slices/patient/customCounsellingEightSlice';
import { setAllDataNine } from '../../redux/slices/patient/customCounsellingNineSlice';
import { setAllDataTen } from '../../redux/slices/patient/customCounsellingTenSlice';

function CounselingNoteEdit({
  patientId,
  appId,
  handleReloadCf,
  editMode,
  vid,
}) {
  const navigate = useNavigate();
  const [demographicsPopup, setDemographicsPopup] = useState(false);
  const [superBill, setSuperBill] = useState(false);
  const [counsellingPopup, setCounsellingPopup] = useState(false);
  const [consultationPopup, setConsultationPopup] = useState(false);
  const [consultationMigrationPopup, setConsultationMigrationPopup] =
    useState(false);
  const [customCounselingOnePopup, setCustomCounselingOnePopup] =
    useState(false);
  const [customCounselingTwoPopup, setCustomCounselingTwoPopup] =
    useState(false);
  const [customCounselingThreePopup, setCustomCounselingThreePopup] =
    useState(false);
  const [customCounselingFourPopup, setCustomCounselingFourPopup] =
    useState(false);
  const [customCounselingFivePopup, setCustomCounselingFivePopup] =
    useState(false);
  const [customCounselingSixPopup, setCustomCounselingSixPopup] =
    useState(false);
  const [customCounselingSevenPopup, setCustomCounselingSevenPopup] =
    useState(false);
  const [customCounselingEightPopup, setCustomCounselingEightPopup] =
    useState(false);
  const [customCounselingNinePopup, setCustomCounselingNinePopup] =
    useState(false);
  const [customCounselingTenPopup, setCustomCounselingTenPopup] =
    useState(false);
  const [soapNotePopup, setSoapNotePopup] = useState(false);
  const [bioPsychoSocial, setBioPsychoSocial] = useState(false);
  const [allData, setAllData] = useState(false);
  const arrivedWithFlag = editMode === true || editMode === 'true';
  const [editAble, setEditAble] = useState(arrivedWithFlag);
  const [editSessionActive, setEditSessionActive] = useState(arrivedWithFlag);
  const [switchedFromList, setSwitchedFromList] = useState(false);

  const [visitId, setVisitId] = useState(vid);
  const [appointmentId, setAppointmentId] = useState('');

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { unlockFlag } = useSelector((state) => state.counsellingNote);
  const { renderFormData } = useSelector((state) => state.counsellingNote);
  const soapButtonList = Array.isArray(allData?.soapButtonList)
    ? allData.soapButtonList.map(String)
    : allData?.soapButtonList && typeof allData.soapButtonList === 'object'
      ? Object.values(allData.soapButtonList).map(String)
      : [];
  const canSignNote = soapButtonList.includes('SN');
  const canCoSignNote = soapButtonList.includes('CO');
  const canUnlockChange = soapButtonList.includes('UCH');
  const canChangeNote =
    soapButtonList.includes('CH') || soapButtonList.includes('O');
  const canAddendum = soapButtonList.includes('ADN');
  const canPoa = soapButtonList.includes('POA'); 
	
  const [reload, setReload] = useState(false);
  const [permission, setPermission] = useState(false);
  const [addendum, setAddendum] = useState(false);
  const [poaPopup, setPoaPopup] = useState(false);
  const [noteNotSaveButSign, setNoteNotSaveButSign] = useState(false);
  const [discardDetail, setDiscardDetail] = useState({
    discard: '',
    soapRevHxId: '',
  });
  const [revHxPopup, setRevHxPopup] = useState({
    status: false,
    soapId: null,
  });
  const [revHxCount, setRevHxCount] = useState('0');
  const [loading, setLoading] = useState(true);
  const [templetId, setTempletId] = useState(0);
  //const [genDetailId, setGenDetailId] = useState(0);
  const [genDetailTempletId, setGenDetailTempletId] = useState(0);
  const [currentTempletId, setCurrentTempletId] = useState(null);

  const { neblaConfirm, resetHandler } = useMessageHandler((data) => {
    if (allData?.soapFlag === '3' || editAble === false) {
      setUiMessage('inf', 'Please unlock the note before export from nabla');
      return false;
    }

    const soapTemletId = allData.progressNoteItem
      ?.filter((item) => item?.variable_name === 'soap')
      ?.map((item) => item?.id);

    if (soapTemletId?.[0] && soapTemletId[0] !== currentTempletId) {
      setCurrentTempletId(soapTemletId[0]);
      setTempletId(soapTemletId[0]);

      dispatch(
        setRenderFormData({
          data: null,
          type: '',
        }),
      );
    }

    return true; // Allow updating neblaConfirm.status
  });

  // const handlePostMessage = () => {
  //   // Simulate sending a message
  //   window.postMessage(
  //     {
  //       nablaCopilot: {
  //         note: [
  //           {
  //             type: 'SOAP_SUBJECTIVE',
  //             title: 'Subjective',
  //             value:
  //               'Experiencing a persistent cough and fever for the last week. The cough started about a week ago and has been worsening. It is sometimes dry and scratchy, and at other times productive with yellow mucus. No chest pain or shortness of breath reported.',
  //           },
  //           {
  //             type: 'SOAP_OBJECTIVE',
  //             title: 'Objective',
  //             value:
  //               '- Imaging results: \n    - X-ray ordered\n- Test results: \n    - Rapid strep test ordered',
  //           },
  //           {
  //             type: 'SOAP_ASSESSMENT',
  //             title: 'Assessment',
  //             value:
  //               '- Persistent cough and fever potentially indicative of an infection, possibly necessitating further investigation through tests such as an X-ray and a rapid strep test.',
  //           },
  //           {
  //             type: 'SOAP_PLAN',
  //             title: 'Plan',
  //             value:
  //               '- Conduct an X-ray to further investigate the cause of the persistent cough and fever.\n- Perform a rapid strep test to rule out or confirm a streptococcal infection.',
  //           },
  //         ],
  //         normalization: {
  //           vitals: [],
  //           pastMedicalHistory: [],
  //           pastSurgicalHistory: [],
  //           pastObstetricHistory: [],
  //           familyHistory: [],
  //           assessment: [
  //             {
  //               uuid: '69c6e886-f854-4fe8-af1d-7566a50d042e',
  //               deleted: false,
  //               selectedEntry: {
  //                 code: 'R05.9',
  //                 description: 'Cough, unspecified',
  //               },
  //               icd10Entry: {
  //                 code: 'R05.9',
  //                 description: 'Cough, unspecified',
  //               },
  //               alternativeIcd10Entries: [
  //                 { code: 'R05.1', description: 'Acute cough' },
  //                 { code: 'R05.2', description: 'Subacute cough' },
  //                 { code: 'R05.3', description: 'Chronic cough' },
  //                 { code: 'R05.4', description: 'Cough syncope' },
  //                 { code: 'R05.8', description: 'Other specified cough' },
  //               ],
  //               familyMember: null,
  //               startDate: null,
  //               endDate: null,
  //             },
  //             {
  //               uuid: '855b84d2-14d2-482b-b0dd-dbab87def3ee',
  //               deleted: false,
  //               selectedEntry: {
  //                 code: 'R50.9',
  //                 description: 'Fever, unspecified',
  //               },
  //               icd10Entry: {
  //                 code: 'R50.9',
  //                 description: 'Fever, unspecified',
  //               },
  //               alternativeIcd10Entries: [
  //                 { code: 'R50.2', description: 'Drug induced fever' },
  //                 { code: 'R50.8', description: 'Other specified fever' },
  //               ],
  //               familyMember: null,
  //               startDate: null,
  //               endDate: null,
  //             },
  //           ],
  //         },
  //       },
  //     },
  //     '*'
  //   );
  // };

  function handleReload(type, copyToAll = '0') {
    if (
      type === 'counselling' ||
      type === 'superBill' ||
      type === 'demo' ||
      type === 'consultation' ||
      type === 'biopsycho' ||
      type === 'customCounsellingOne' ||
      type === 'customCounsellingTwo' ||
      type === 'customCounsellingThree' ||
      type === 'customCounsellingFour' ||
      type === 'customCounsellingFive' ||
      type === 'customCounsellingSix' ||
      type === 'customCounsellingSeven' ||
      type === 'customCounsellingEight' ||
      type === 'customCounsellingNine' ||
      type === 'customCounsellingTen' ||
      type === 'addendum' ||
      type === 'soapnote'
    ) {
      setTimeout(() => {
        handleSaveCounseling(() => setReload(!reload), copyToAll);
      }, 1000);
    } else {
      setReload(!reload);
    }
  }

  const hadleCancelCoun = () => {
    if (allData?.appGroupId !== '0') {
      navigate(-1);
    } else {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/counNote/${patientId}`);
    }
	setEditSessionActive(false);
    dispatch(setUnlockFlag(''));
  };

  useEffect(() => {
    setAppointmentId(appId);
  }, [appId]);

  useEffect(() => {
    dispatch(
      setRenderFormData({
        data: null,
        type: '',
      }),
    );
  }, [dispatch, patientId]);

  const soapStrProcessViaNebula = async (soapId, nablaStr) => {
    try {
      const response = await post(
        'api/patient/progressNote/soapStrProcessViaNebula',
        {
          soapId: soapId,
          soapNonStructural: nablaStr,
          loginUserId: user?.id,
        },
      );
      if (response.status === 200) {
        if (response?.data?.status === 'success') {
          setUiMessage(
            'suc',
            'Non Structural data has been save/updated successfully.',
          );
          resetHandler();
          handleReload('soapnote');

          dispatch(
            setRenderFormData({
              data: { soapStr: response.data.renderDesc },
              type: 'soapnote',
            }),
          );
        } else {
          setUiMessage('err', 'err', 'Non Structural data has not been saved.');
        }
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  const processNablaContent = async (soapId, noteStatus, nablaContent) => {
    if (
      typeof soapId === 'undefined' ||
      soapId === 'undefined' ||
      soapId === '' ||
      soapId === 0
    ) {
      setUiMessage('inf', 'Please export it from progress note section only');
      return false;
    }
    if (noteStatus === '3' || editAble === false) {
      setUiMessage('inf', 'Please unlock the note before export from nabla');
      return false;
    }

    const response = await post(
      'api/patient/progressNote/createLogForNablaExport',
      {
        soapId: soapId,
        nablaContent: nablaContent,
        loginUserId: user?.id,
      },
    );
    if (response?.status === 200) {
      if (response?.data?.status === 'success') {
        let soapStr = '';
        let nablaNote = nablaContent.nablaCopilot.note;
        for (let key in nablaNote) {
          if (nablaNote.hasOwnProperty(key)) {
            let val = nablaNote[key];
            soapStr += '<b>' + val.title + '</b><br>' + val.value + '<br><br>';
          }
        }
        soapStrProcessViaNebula(soapId, soapStr);
      } else {
        setUiMessage('inf', response?.data?.message);
      }
    }
  };

  const handleChangeAppStatus = async (
    appId,
    appStatus,
    currentStatusAutoIncId,
    patientId,
    copyToAll = '0',
  ) => {
    try {
      const response = await post(
        'api/appointment/Appointment/changeCurrentStatus',
        {
          appointmentId: appId,
          currentStatusId: parseInt(appStatus) === 16 ? 7 : appStatus,
          currentStatusAutoIncId: currentStatusAutoIncId,
          patient_id: patientId,
          loginUserId: user?.id,
          recurringVal: 0,
          reason: '',
          copyToAll: copyToAll,
        },
      );
      if (response?.status === 200) {
        if (response?.data?.successCode === 1) {
          setUiMessage('suc', 'Appointment status changed successfully.');
          if (noteNotSaveButSign) {
            handleCounsellingSign(allData?.soapId);
            setNoteNotSaveButSign(false);
          }
        } else {
          setUiMessage('inf', 'Unable to change appointment status.');
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleSaveCounseling = async (callback, copyToAll = '0') => {
    try {
		const templateId =
        allData?.selTempId || allData?.templateList?.[0]?.id || null;
      if (!templateId) {
        setUiMessage(
          'err',
          'Counseling template is not mapped for this visit. Unable to save.',
        );
        return;
      }
      const response = await post('api/patient/progressNote/saveProgressNote', {
        patientId: patientId,
        appointmentId: appointmentId,
        visitId: visitId,
        soapId: allData?.soapId,
        templateId: templateId,
        staffUserId: user?.id,
        getstr: getHtmlStr(),
        appGroupId: allData?.appGroupId,
      });
      if (response.status === 200) {
        if (
          response?.data?.counselingDoneArr?.currentStatusId &&
          response?.data?.counselingDoneArr?.currentStatusAutoIncId
        ) {
          handleChangeAppStatus(
            appId,
            response?.data?.counselingDoneArr?.currentStatusId,
            response?.data?.counselingDoneArr?.currentStatusAutoIncId,
            patientId,
            copyToAll,
          );
        } else {
          setUiMessage('err', 'Status not updated.');
        }
        handleReloadCf();
        callback();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        if (patientId && appointmentId) {
          const response = await post(
            'api/patient/progressNote/manageCounselingNote',
            {
              patientId: patientId,
              appointmentId: appointmentId,
              visitId: visitId,
              staffUserId: user?.id,
              mode: unlockFlag,
            },
          );
          if (response.status === 200 && isMounted) {
            setAllData(response?.data);
            setLoading(false);
            setPermission(response?.data?.changePermission === '1');

            const genDetailId = response?.data?.progressNoteItem
              ?.filter((data) => data?.variable_name === 'general_detail')
              ?.map((c) => c?.id);

            const soapFlag = String(response?.data?.soapFlag ?? '');
            const isEditFlag = editMode === true || editMode === 'true';
            const genDetailEmpty = Boolean(
              response?.data?.defaultSaveItem &&
                genDetailId &&
                response?.data?.defaultSaveItem[genDetailId[0]]?.genDetail
                  ?.length === 0,
            );
            const isCase2Switch = switchedFromList && isEditFlag;

            if (genDetailEmpty) {
              setSuperBill(true);
              setTempletId(genDetailId[0]);
              if (!isCase2Switch) {
                setEditAble(true);
                setEditSessionActive(true);
              }
              dispatch(setUnlockFlag(''));
              dispatch(
                setRenderFormData({
                  data: null,
                  type: '',
                }),
              );
            }
            if (response?.data?.appGroupId !== '0') {
              setGenDetailTempletId(genDetailId[0]);
            }
            if (editSessionActive || (genDetailEmpty && !isCase2Switch)) {
              setEditAble(true);
            } else if (isCase2Switch) {
              setEditAble(false);
            } else if (soapFlag === '1') {
              setEditAble(true);
            } else {
              setEditAble(false);
            }
            setDiscardDetail(response?.data?.discardDetail);
            setRevHxCount(response?.data?.revHxCount);
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [
    patientId,
    appointmentId,
    visitId,
    user?.id,
    unlockFlag,
    reload,
    dispatch,
	editMode,
	editSessionActive,
    switchedFromList,
  ]);

  useEffect(() => {
    if (renderFormData?.data) {
      let renderData = '';
      let genDetalData = '';

      renderData = ReactDOMServer.renderToString(
        (renderFormData?.type === 'demo' && (
          <RenderDemoGraphics demodata={renderFormData?.data} id={templetId} />
        )) ||
          (renderFormData?.type === 'superBill' && (
            <RenderGeneralDetails data={renderFormData?.data} id={templetId} />
          )) ||
          (renderFormData?.type === 'counselling' && (
            <RenderCounselingFollowUp
              data={renderFormData?.data}
              id={templetId}
            />
          )) ||
          (renderFormData?.type === 'biopsycho' && (
            <RenderBioPsychoSocial data={renderFormData?.data} id={templetId} />
          )) ||
          (renderFormData?.type === 'consultation' && (
            <RenderConsultation
              data={renderFormData?.data}
              id={templetId}
              isMigratioin={
                renderFormData?.data_migration === '1' &&
                renderFormData?.type === 'consultation'
              }
            />
          )) ||
          (renderFormData?.type === 'customCounsellingOne' && (
            <RenderCustomCounselingOne
              data={renderFormData?.data}
              id={templetId}
            />
          )) ||
          (renderFormData?.type === 'customCounsellingTwo' && (
            <RenderCustomCounselingTwo
              data={renderFormData?.data}
              id={templetId}
            />
          )) ||
          (renderFormData?.type === 'customCounsellingThree' && (
            <RenderCustomCounselingThree
              data={renderFormData?.data}
              id={templetId}
            />
          )) ||
          (renderFormData?.type === 'customCounsellingFour' && (
            <RenderCustomCounselingFour
              data={renderFormData?.data}
              id={templetId}
            />
          )) ||
          (renderFormData?.type === 'customCounsellingFive' && (
            <RenderCustomCounselingFive
              data={renderFormData?.data}
              id={templetId}
            />
          )) ||
          (renderFormData?.type === 'customCounsellingSix' && (
            <RenderCustomCounselingSix
              data={renderFormData?.data}
              id={templetId}
            />
          )) ||
          (renderFormData?.type === 'customCounsellingSeven' && (
            <RenderCustomCounselingSeven
              data={renderFormData?.data}
              id={templetId}
            />
          )) ||
          (renderFormData?.type === 'customCounsellingEight' && (
            <RenderCustomCounselingEight
              data={renderFormData?.data}
              id={templetId}
            />
          )) ||
          (renderFormData?.type === 'customCounsellingNine' && (
            <RenderCustomCounselingNine
              data={renderFormData?.data}
              id={templetId}
            />
          )) ||
          (renderFormData?.type === 'customCounsellingTen' && (
            <RenderCustomCounselingTen
              data={renderFormData?.data}
              id={templetId}
            />
          )) ||
          (renderFormData?.type === 'soapnote' && (
            <RenderSoapCounsellingData
              data={renderFormData?.data}
              id={templetId}
            />
          )),
      );
      if (
        allData?.appGroupId !== '0' &&
        renderFormData?.type === 'counselling' &&
        genDetailTempletId
      ) {
        genDetalData = ReactDOMServer.renderToString(
          <RenderGeneralDetails
            data={renderFormData?.data}
            id={genDetailTempletId}
          />,
        );
      }

      // Merge state updates into one setAllData call
      setAllData((prev) => {
        const updatedData = {
          ...prev,
          saveItemList: prev.saveItemList
            ? prev.saveItemList.map((item) => {
                if (item.section_id === templetId) {
                  return { ...item, section_value: renderData };
                } else if (item?.section_id === genDetailTempletId) {
                  return { ...item, section_value: genDetalData };
                } else {
                  return item;
                }
              })
            : [],
          defaultSaveItem: {
            ...prev.defaultSaveItem,
            [templetId]: {
              ...(prev.defaultSaveItem?.[templetId] || {}),
              ...renderFormData?.data,
            },
          },
        };
        return updatedData;
      });
    }
  }, [renderFormData, templetId, genDetailTempletId, allData?.appGroupId]);

  const handleCounsellingSign = async (soapId) => {
	  if (!canSignNote) {
      setUiMessage('err', 'You are not authorized to sign this note.');
      return;
    }
    const genDetailId = allData?.progressNoteItem
      ?.filter((data) => data?.variable_name === 'general_detail')
      ?.map((c) => c?.id);

    if (
      allData?.defaultSaveItem[genDetailId[0]]?.genDetail?.length === 0 ||
      allData?.defaultSaveItem[genDetailId[0]]?.genDetail?.procName.length === 0
    ) {
      setUiMessage(
        'err',
        'Please add procedure code in general detail section.',
      );
      return;
    }

    try {
      const response = await post('api/patient/progressNote/saveSignInDate', {
        soapId: soapId,
        staffUserId: user?.id,
      });
      if (response.status === 200) {
        navigate(`${DEFAULT_LOCAL_PATH}/patient/counNote/${patientId}`);
        handleReloadCf();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  const handleCounsellingSignNotNotSave = async (soapId) => {
    try {
      const genDetailId = allData?.progressNoteItem
        ?.filter((data) => data?.variable_name === 'general_detail')
        ?.map((c) => c?.id);

      if (
        allData?.defaultSaveItem &&
        genDetailId &&
        allData?.defaultSaveItem[genDetailId[0]]?.genDetail.length === 0
      ) {
        setSuperBill(true);
        setEditAble(true);
        setTempletId(genDetailId[0]);
        setNoteNotSaveButSign(true);
        dispatch(setUnlockFlag(''));
      } else {
        handleCounsellingSign(soapId);
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleCounsellingCoSign = async (soapId) => {
	  if (!canCoSignNote) {
      setUiMessage('err', 'You are not authorized to co-sign this note.');
      return;
    }
    try {
      const response = await post('api/notes/progressNote/coSaveSignInDate', {
        soapId: soapId,
        userloginId: user?.id,
      });
      if (response.status === 200) {
        handleReloadCf();
        handleReload();
        if (
          response?.data?.counselingDoneArr?.currentStatusId &&
          response?.data?.counselingDoneArr?.currentStatusAutoIncId
        ) {
          handleChangeAppStatus(
            appId,
            response?.data?.counselingDoneArr?.currentStatusId,
            response?.data?.counselingDoneArr?.currentStatusAutoIncId,
            patientId,
          );
        } else {
          setUiMessage('err', 'Status not update.');
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  const handleSoapItemPopup = (type, formId) => {
    setTempletId(formId);
    if (type === 'demographics') {
      setDemographicsPopup(true);
    } else if (type === 'general_detail') {
      setSuperBill(true);
    } else if (type === 'follow-up-counseling') {
      setCounsellingPopup(true);
    } else if (type === 'biopsychosocial_intake') {
      setBioPsychoSocial(true);
    } else if (type === 'consultation') {
      if (allData?.data_migration === '1') {
        setConsultationMigrationPopup(true);
      } else {
        setConsultationPopup(true);
      }
    } else if (type === 'custom_counseling1') {
      setCustomCounselingOnePopup(true);
    } else if (type === 'custom_counseling2') {
      setCustomCounselingTwoPopup(true);
    } else if (type === 'custom_counseling3') {
      setCustomCounselingThreePopup(true);
    } else if (type === 'custom_counseling4') {
      setCustomCounselingFourPopup(true);
    } else if (type === 'custom_counseling5') {
      setCustomCounselingFivePopup(true);
    } else if (type === 'custom_counseling6') {
      setCustomCounselingSixPopup(true);
    } else if (type === 'custom_counseling7') {
      setCustomCounselingSevenPopup(true);
    } else if (type === 'custom_counseling8') {
      setCustomCounselingEightPopup(true);
    } else if (type === 'custom_counseling9') {
      setCustomCounselingNinePopup(true);
    } else if (type === 'custom_counseling10') {
      setCustomCounselingTenPopup(true);
    } else if (type === 'soap') {
      setSoapNotePopup(true);
    }
    dispatch(
      setRenderFormData({
        data: null,
        type: '',
      }),
    );
    setNoteNotSaveButSign(false);
  };

  const handleCounsellingEdit = (appId, visitId, permisson, soapFlag) => {
    setAppointmentId(appId);
    setVisitId(visitId);
    setSwitchedFromList(true);
    setEditSessionActive(false);
    dispatch(setUnlockFlag(''));
    if (arrivedWithFlag) {
      setEditAble(false);
      setPermission(false);
    } else if (String(soapFlag) === '3') {
      setEditAble(false);
      setPermission(false);
    } else if (permisson === '1') {
      setEditAble(true);
      setPermission(true);
    } else {
      setEditAble(false);
      setPermission(false);
    }
  };

  function getHtmlStr() {
    let str = '';
    const sectionBlocks = document.querySelectorAll('.sectionBlock');

    sectionBlocks.forEach((block) => {
      const blockId = block.getAttribute('value');

      if (blockId) {
        if (window.getComputedStyle(block).display === 'block') {
          const label = document.querySelector(
            `#sectionId_${blockId}`,
          )?.textContent;
          const val = document.querySelector(
            `#sectionVal_${blockId}`,
          )?.innerHTML;
          str += val !== undefined ? `${blockId}|||${label}|||${val}$=#=!` : '';
        }
      }
    });
    return str;
  }

  const handleChangeCounNote = async (soapId) => {
	  if (!canUnlockChange && !canChangeNote) {
      setUiMessage('err', 'You are not authorized to change this note.');
      return;
    }
    try {
      const response = await post('api/patient/progressNote/noteUnlockChange', {
        soapId: soapId,
        loginUserId: user?.id,
      });
      if (response?.status === 200) {
        setEditAble(true);
		setEditSessionActive(true);
        setSwitchedFromList(false);
        setDiscardDetail({
          discard: response?.data?.discard,
          soapRevHxId: response?.data?.soapRevHxId,
        });
        handleReload();
        dispatch(setUnlockFlag('unlock'));
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleDiscardRevHx = async (soapId, revHxId) => {
    try {
      if (revHxId) {
        const response = await post(
          'api/patient/progressNote/discardNoteChange',
          {
            soapId: soapId,
            soapRevHxId: revHxId,
          },
        );
        if (response?.status === 200) {
			setEditSessionActive(false);
          dispatch(setUnlockFlag(''));
          handleReload();
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleOpenRevHxPopUp = (soapId) => {
    setRevHxPopup({
      status: true,
      soapId: soapId,
    });
  };

  const handlePrint = async () => {
    try {
      const printContent = getPrintContent(allData);

      const newWindow = window.open('', '_blank', 'height=700,width=900');
      if (!newWindow) {
        setUiMessage(
          'war',
          'Popup blocked! Please allow popups for this website.',
        );
        return;
      }

      newWindow.document.write(printContent);
      newWindow.document.close();
      setTimeout(() => newWindow.print(), 0);
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const getPrintContent = (data) => {
    const { printHeaderFooterInfo, typeOfVisit } = allData;
    const layout = (
      <PrintLayout headerFooterInfo={printHeaderFooterInfo}>
        <CounselingPrintPopup allData={data} template={typeOfVisit} />
      </PrintLayout>
    );
    let printContent = ReactDOMServer.renderToString(layout);

    // Include a <link> tag to reference the external CSS file
    printContent = `
        <html>
            <head>
                <link rel="stylesheet" type="text/css" href="${DEFAULT_LOCAL_PATH}/styleprint.css">
            </head>
            <body>${printContent}</body>
        </html>
    `;

    return printContent;
  };

  return (
    <div className="chart-right-col-mid-bdy">
      <div className="c-mid-bdy-edit-blk">
        <div className="dos-blk">
          <div className="t-plan-hdr">
            <span className="bold">DOS</span>
            <input
              type="search"
              className="main-search"
              placeholder="Search date..."
            />
          </div>
          <div className="t-plan-bdy">
            {allData?.dosList &&
              allData?.dosList.map(
                (data, i) =>
                  data?.note_type === '3' && (
                    <div
                      key={i}
                      className={
                        data?.appointment_id === appointmentId
                          ? 't-plan-bdy-rw councel-note-active-dos'
                          : i % 2 === 0
                            ? 't-plan-bdy-rw'
                            : 't-plan-bdy-rw alt-rw'
                      }
                      onClick={(() => {
                        if (data?.recordPermission === '1') {
                          return () =>
                            handleCounsellingEdit(
                              data?.appointment_id,
                              data?.visit_id,
                              data?.recordPermission,
                              data?.soap_flag,
                            );
                        } else {
                          if (data?.soap_flag === '1') {
                            return null;
                          } else {
                            return () =>
                              handleCounsellingEdit(
                                data?.appointment_id,
                                data?.visit_id,
                                data?.recordPermission,
                                data?.soap_flag,
                              );
                          }
                        }
                      })()}
                    >
                      <span className="fontsize15">{data?.tovName}</span>
                      <span className="sec-colr fontsize13">
                        {data?.consult_date} |
                        {(() => {
                          if (data?.soap_flag === '1') {
                            return (
                              <span className="fontsize13 red"> Pending</span>
                            );
                          } else if (data?.soap_flag === '2') {
                            return (
                              <span className="fontsize13 sec-colr">
                                {' '}
                                Unsigned
                              </span>
                            );
                          } else {
                            return (
                              <span className="fontsize13 sec-colr">
                                {' '}
                                Signed
                              </span>
                            );
                          }
                        })()}
                      </span>
                      <span className="sec-colr">{data?.resourceName}</span>
                    </div>
                  ),
              )}
          </div>
        </div>
        <div className="template-blk">
          {loading ? (
            <b>Loading....</b>
          ) : (
            <>
              {(() => {
                let newArray =
                  allData &&
                  allData?.saveItemList.filter(
                    (obj) => obj.section_value !== '',
                  );

                return (
                  allData?.progressNoteItem &&
                  allData?.progressNoteItem?.map((item, i) => {
                    return (
                      <div
                        className={
                          item?.itemLink === 'hide'
                            ? 'hide'
                            : 'sectionBlock smart-tag-sec'
                        }
                        key={i}
                        id={'sectionName_' + item?.variable_name}
                        value={item?.id}
                      >
                        {(() => {
                          if (editAble) {
                            return (
                              <>
                                <div className="smart-tag-add-rem">
                                  <span
                                    className="smart-tag-name"
                                    onClick={() =>
                                      handleSoapItemPopup(
                                        item?.variable_name,
                                        item?.id,
                                      )
                                    }
                                    id={'sectionId_' + item?.id}
                                  >
                                    {allData?.data_migration === '1' &&
                                    item?.variable_name === 'consultation'
                                      ? 'Note'
                                      : item?.preferred_label}
                                  </span>
                                  <span className="smart-tag-rem">[X]</span>
                                </div>
                                {allData?.soapFlag === '1' ? (
                                  <>
                                    {item?.variable_name === 'demographics' && (
                                      <RenderDemoGraphics
                                        demodata={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'general_detail' && (
                                      <RenderGeneralDetails
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'follow-up-counseling' && (
                                      <RenderCounselingFollowUp
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'biopsychosocial_intake' && (
                                      <RenderBioPsychoSocial
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name === 'consultation' && (
                                      <RenderConsultation
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                        isMigration={
                                          allData?.data_migration === '1' &&
                                          item?.variable_name === 'consultation'
                                        }
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'custom_counseling1' && (
                                      <RenderCustomCounselingOne
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'custom_counseling2' && (
                                      <RenderCustomCounselingTwo
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'custom_counseling3' && (
                                      <RenderCustomCounselingThree
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'custom_counseling4' && (
                                      <RenderCustomCounselingFour
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'custom_counseling5' && (
                                      <RenderCustomCounselingFive
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'custom_counseling6' && (
                                      <RenderCustomCounselingSix
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'custom_counseling7' && (
                                      <RenderCustomCounselingSeven
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'custom_counseling8' && (
                                      <RenderCustomCounselingEight
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'custom_counseling9' && (
                                      <RenderCustomCounselingNine
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name ===
                                      'custom_counseling10' && (
                                      <RenderCustomCounselingTen
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                    {item?.variable_name === 'soap' && (
                                      <RenderSoapCounsellingData
                                        data={
                                          allData?.defaultSaveItem[item?.id]
                                        }
                                        id={item?.id}
                                      />
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {(() => {
                                      const saveItemElement =
                                        newArray?.filter(
                                          (itm) => itm?.section_id === item?.id,
                                        ) || [];

                                      if (saveItemElement.length > 0) {
                                        return (
                                          <div
                                            className={`gnrl-detail-section smart-tag-bdy recrd-nt-rw ${preLineClass(
                                              saveItemElement[0]?.section_value,
                                            )}`}
                                            id={'sectionVal_' + item?.id}
                                          >
                                            <span
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  saveItemElement[0]
                                                    ?.section_value,
                                              }}
                                            />
                                          </div>
                                        );
                                      } else {
                                        switch (item?.variable_name) {
                                          case 'demographics':
                                            return (
                                              <RenderDemoGraphics
                                                demodata={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'general_detail':
                                            return (
                                              <RenderGeneralDetails
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'follow-up-counseling':
                                            return (
                                              <RenderCounselingFollowUp
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'biopsychosocial_intake':
                                            return (
                                              <RenderBioPsychoSocial
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'consultation':
                                            return (
                                              <RenderConsultation
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                                isMigration={
                                                  allData?.data_migration ===
                                                    '1' &&
                                                  item?.variable_name ===
                                                    'consultation'
                                                }
                                              />
                                            );
                                          case 'custom_counseling1':
                                            return (
                                              <RenderCustomCounselingOne
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'custom_counseling2':
                                            return (
                                              <RenderCustomCounselingTwo
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'custom_counseling3':
                                            return (
                                              <RenderCustomCounselingThree
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'custom_counseling4':
                                            return (
                                              <RenderCustomCounselingFour
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'custom_counseling5':
                                            return (
                                              <RenderCustomCounselingFive
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'custom_counseling6':
                                            return (
                                              <RenderCustomCounselingSix
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'custom_counseling7':
                                            return (
                                              <RenderCustomCounselingSeven
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'custom_counseling8':
                                            return (
                                              <RenderCustomCounselingEight
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'custom_counseling9':
                                            return (
                                              <RenderCustomCounselingNine
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'custom_counseling10':
                                            return (
                                              <RenderCustomCounselingTen
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          case 'soap':
                                            return (
                                              <RenderSoapCounsellingData
                                                data={
                                                  allData?.defaultSaveItem[
                                                    item?.id
                                                  ]
                                                }
                                                id={item?.id}
                                              />
                                            );
                                          default:
                                            return null;
                                        }
                                      }
                                    })()}
                                  </>
                                )}
                              </>
                            );
                          } else {
                            return (
                              <>
                                <div className="smart-tag-add-rem">
                                  <span>{item?.preferred_label}</span>
                                </div>
                                {newArray.map((section, index) => (
                                  <span key={index}>
                                    {item?.id === section?.section_id && (
                                      <div
                                        key={index}
										className={preLineClass(
                                          section?.section_value,
                                        )}
                                        style={{
                                          borderBottom: '1px dotted #e6e6e6',
                                        }}
                                      >
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: section?.section_value,
                                          }}
                                        />
                                      </div>
                                    )}
                                  </span>
                                ))}
                              </>
                            );
                          }
                        })()}
                      </div>
                    );
                  })
                );
              })()}
            </>
          )}
          <div
            style={{
              float: 'left',
              width: '100%',
            }}
          >
            {(() => {
              if (!allData?.coSignerStr) {
                return (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: allData?.signStr,
                    }}
                  />
                );
              } else {
                return (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: allData?.coSignerStr,
                    }}
                  />
                );
              }
            })()}

            {allData?.addendumList?.length > 0 && (
              <div className="addendumBlock">
                <p style={{ marginLeft: '9px', marginTop: '30px' }}>
                  <strong>Addendum:</strong>
                </p>
                {allData?.addendumList?.map((item, i) => {
                  return (
                    <div key={i}>
                      <p style={{ marginLeft: '9px' }}>
                        <b>Provider Name & Credentials: </b>{' '}
                        {item?.ProviderDetail} <br />
                        <b>Original Note Date: </b> {item?.originalNote} <br />
                        <b>Addendum Date: </b> {item?.addendumDate} <br />
                        <b>Added By: </b> {item?.addedBy} <br />
                        <b>Reason for Addendum: </b> <br />
                        <span
							className={preLineClass(item?.reason)}
                          dangerouslySetInnerHTML={{ __html: item?.reason }}
                        />{' '}
                        <br />
                        <b>Additional Information: </b> <br />
                        <span
							className={preLineClass(item?.description)}
                          dangerouslySetInnerHTML={{
                            __html: item?.description,
                          }}
                        />
                      </p>
                      <br />
                    </div>
                  );
                })}
              </div>
            )}

            <div className="gnrl-dtl-btn-rw">
              {allData?.soapFlag === '1' && ( //note pendong
                <>
                 {canSignNote && (
                    <button
                      className="actn-yes"
                      onClick={() =>
                        // handleSaveCounseling(() => setReload(!reload))
                        handleCounsellingSignNotNotSave(allData?.soapId)
                      }
                      style={{ width: 'unset' }}
                    >
                      {/* itShould be save and sign but it change to Sign */}
                      {/* Save & Sign later */}
                      Sign
                    </button>
                  )}
                  <button
                    className="actn-No"
                    onClick={hadleCancelCoun}
                    style={{ width: 'unset' }}
                  >
                    Cancel
                  </button>
                </>
              )}
              {(allData?.soapFlag === '2' || allData?.soapFlag === '3') &&
               (permission ||
                  canSignNote ||
                  canCoSignNote ||
                  canUnlockChange ||
                  canChangeNote) && (
                  <>
                    {allData?.soapFlag === '3' ? (
                      editAble ? (
                        <>
                          {canSignNote && allData?.sign_status === '0' && (
                              <button
                                className="actn-yes"
                                onClick={() =>
                                  handleCounsellingSign(allData?.soapId)
                                }
                              >
                                Sign
                              </button>
                            )}
                          {canCoSignNote && (

                              <button
                                className="actn-yes"
                                onClick={() =>
                                  handleCounsellingCoSign(allData?.soapId)
                                }
                              >
                                Co-Sign
                              </button>
                            )}

                          <button
                            className="actn-No"
                            onClick={hadleCancelCoun}
                            style={{ width: 'unset' }}
                          >
                            Cancel
                          </button>
						  {canAddendum && (
                          <button
                            className="actn-No"
                            onClick={() => setAddendum(true)}
                            style={{ width: 'unset' }}
                          >
                            Addendum
                          </button>
						  )}
                          {canPoa && (
                          <button
                            className="actn-No"
                            onClick={() => setPoaPopup(true)}
                            style={{ width: 'unset' }}
                          >
                            POA
                          </button>
						   )}
                        </>
                      ) : (
                        <>
						{canUnlockChange && (
                          <button
                            className="actn-No"
                            onClick={() =>
                              handleChangeCounNote(allData?.soapId)
                            }
                            style={{ width: 'unset' }}
                          >
                            Unlock & Change
                          </button>
						  )}
                          {canAddendum && (
                          <button
                            className="actn-No"
                            onClick={() => setAddendum(true)}
                            style={{ width: 'unset' }}
                          >
                            Addendum
                          </button>
						  )}
                          {canPoa && (
                          <button
                            className="actn-No"
                            onClick={() => setPoaPopup(true)}
                            style={{ width: 'unset' }}
                          >
                            POA
                          </button>
						   )}
                        </>
                      )
                    ) : (
                      <>
                        {canSignNote && (
                          <button
                            className="actn-yes"
                            style={{ width: 'unset' }}
                            onClick={() =>
                              handleCounsellingSign(allData?.soapId)
                            }
                          >
                            Sign
                          </button>
                        )}
                        {canCoSignNote && (

                            <button
                              className="actn-yes"
                              style={{ width: 'unset' }}
                              onClick={() =>
                                handleCounsellingCoSign(allData?.soapId)
                              }
                            >
                              Co-Sign
                            </button>
                          )}
                        {editAble ? (
                          <button
                            className="actn-No"
                            onClick={hadleCancelCoun}
                            style={{ width: 'unset' }}
                          >
                            Cancel
                          </button>
                        ) : (
							canChangeNote && (
                          <button
                            className="actn-No"
                            onClick={() =>
                              handleChangeCounNote(allData?.soapId)
                            }
                            style={{ width: 'unset' }}
                          >
                            Change
                          </button>
						  )
                        )}
                      </>
                    )}
                    <button
                      className="actn-yes"
                      style={{ width: 'unset' }}
                      onClick={handlePrint}
                    >
                      Print
                    </button>
                  </>
                )}
              {discardDetail?.discard === 'show' &&
                discardDetail?.soapRevHxId && (
                  <button
                    className="actn-No"
                    onClick={() =>
                      handleDiscardRevHx(
                        allData?.soapId,
                        discardDetail?.soapRevHxId,
                      )
                    }
                    style={{ width: 'unset' }}
                  >
                    Discard
                  </button>
                )}
              {parseInt(revHxCount) > 0 && (
                <button
                  className="actn-No"
                  onClick={() => handleOpenRevHxPopUp(allData?.soapId)}
                  style={{ width: 'unset' }}
                >
                  Rev. Hx
                </button>
              )}
            </div>
          </div>
        </div>
        {/* <div>
          <h1>React PostMessage Hook Example</h1>
          <button onClick={handlePostMessage}>Send Message</button>
          <button onClick={resetHandler}>Reset State</button>
          <p>Current State: {JSON.stringify(neblaConfirm)}</p>
        </div> */}
      </div>
      <div className="chart-right-section">
        <PatVisitRightSidebar
          appId={appId}
          headerData={allData?.hearderDetail}
          patientId={patientId}
        />
      </div>

      {demographicsPopup && (
        <DemographicsPopup
          handleClose={() => setDemographicsPopup(false)}
          patientId={patientId}
          handleReload={handleReload}
        />
      )}
      {superBill && (
        <SuperBillPopup
          handleClose={() => setSuperBill(false)}
          patientId={patientId}
          appointmentId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
          appGrpId={allData?.appGroupId}
          templateId={allData?.selTempId}
        />
      )}
      {counsellingPopup && (
        <CounsellingPopup
          handleClose={() => setCounsellingPopup(false)}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
          appGrpId={allData?.appGroupId}
          templateId={allData?.selTempId}
        />
      )}
      {consultationPopup && (
        <ConsultationPopup
          handleClose={() => setConsultationPopup(false)}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}
      {consultationMigrationPopup && (
        <ConsultationMigrationPopup
          handleClose={() => setConsultationMigrationPopup(false)}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}
      {bioPsychoSocial && (
        <BioPsychoSocialPopUp
          handleClose={() => setBioPsychoSocial(false)}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}
      {customCounselingOnePopup && (
        <CustomCounsellingOnePopup
          handleClose={() => {
            setCustomCounselingOnePopup(false);
            dispatch(setAllDataOne(null));
          }}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}
      {customCounselingTwoPopup && (
        <CustomCounsellingTwoPopup
          handleClose={() => {
            setCustomCounselingTwoPopup(false);
            dispatch(setAllDataTwo(null));
          }}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}

      {customCounselingThreePopup && (
        <CustomCounsellingThreePopup
          handleClose={() => {
            setCustomCounselingThreePopup(false);
            dispatch(setAllDataThree(null));
          }}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}

      {customCounselingFourPopup && (
        <CustomCounsellingFourPopup
          handleClose={() => {
            setCustomCounselingFourPopup(false);
            dispatch(setAllDataFour(null));
          }}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}

      {customCounselingFivePopup && (
        <CustomCounsellingFivePopup
          handleClose={() => {
            setCustomCounselingFivePopup(false);
            dispatch(setAllDataFive(null));
          }}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}

      {customCounselingSixPopup && (
        <CustomCounsellingSixPopup
          handleClose={() => {
            setCustomCounselingSixPopup(false);
            dispatch(setAllDataSix(null));
          }}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}

      {customCounselingSevenPopup && (
        <CustomCounsellingSevenPopup
          handleClose={() => {
            setCustomCounselingSevenPopup(false);
            dispatch(setAllDataSeven(null));
          }}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}

      {customCounselingEightPopup && (
        <CustomCounsellingEightPopup
          handleClose={() => {
            setCustomCounselingEightPopup(false);
            dispatch(setAllDataEight(null));
          }}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}

      {customCounselingNinePopup && (
        <CustomCounsellingNinePopup
          handleClose={() => {
            setCustomCounselingNinePopup(false);
            dispatch(setAllDataNine(null));
          }}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}

      {customCounselingTenPopup && (
        <CustomCounsellingTenPopup
          handleClose={() => {
            setCustomCounselingTenPopup(false);
            dispatch(setAllDataTen(null));
          }}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}
      {soapNotePopup && (
        <SoapNotePopup
          handleClose={() => setSoapNotePopup(false)}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          handleReload={handleReload}
        />
      )}
      {addendum && (
        <AddendumPopup
          soapId={allData?.soapId}
          hanleClose={() => setAddendum(false)}
          handleReload={handleReload}
        />
      )}
      {poaPopup && (
        <ProofOfAppPopup
          handleClose={() => setPoaPopup(false)}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          soapId={allData?.soapId}
          noteType={allData?.noteType}
        />
      )}
      {revHxPopup.status && (
        <RevisionHxListPopup
          soapId={revHxPopup.soapId}
          patientId={patientId}
          appId={appointmentId}
          visitId={allData?.visitId}
          dataForPrint={allData}
          handleClose={() => setRevHxPopup({ status: false, soapId: null })}
        />
      )}
      {neblaConfirm.status && (
        <ConfirmDialog
          title={`Confirmation`}
          bodytext={`Are you trying to export note for Patient Name: ${allData?.patientName} for DOS: ${allData?.dateOfVisit} ?`}
          closeDialog={() => {
            resetHandler();
            const genDetailId = allData.progressNoteItem
              ?.filter((data) => data?.variable_name === 'general_detail')
              ?.map((c) => c?.id);

            if (genDetailId) {
              setCurrentTempletId(genDetailId[0]);
              setTempletId(() => genDetailId[0]);
              dispatch(
                setRenderFormData({
                  data: null,
                  type: '',
                }),
              );
            }
          }}
          asyncClose={true}
          successDialog={() =>
            processNablaContent(
              allData?.soapId,
              allData?.soapFlag,
              neblaConfirm?.data,
            )
          }
        />
      )}
    </div>
  );
}

export default CounselingNoteEdit;
